module.exports = __webpack_public_path__ + "img/ucc_logo.7c665e51.png";